"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var utils_1 = __importDefault(require("@nexys/utils"));
var view_1 = require("../../ui/view");
var View = function (_a) {
    var data = _a.data, fields = _a.fields, classNames = _a.classNames;
    return (react_1["default"].createElement(react_1["default"].Fragment, null, fields.map(function (f, i) {
        var value = utils_1["default"].ds.get(f.name, data);
        var displayValue = f.render ? f.render(data) : value;
        return (react_1["default"].createElement(view_1.Wrapper, { key: i, label: f.label, classNames: { labelContainer: classNames === null || classNames === void 0 ? void 0 : classNames.label } },
            react_1["default"].createElement(Typography_1["default"], { className: classNames === null || classNames === void 0 ? void 0 : classNames.value }, displayValue)));
    })));
};
exports["default"] = View;
